exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.below-title-post-count {\n\tbottom: 0px !important;\n\tleft: 0px;\n}\n", ""]);

// exports
